import { HeadshotProps } from '../Headshot/headshot.types';
import { LinkProps } from '../Link/link.types';

export enum PlayerMatchupTypes {
  PITCHERPREGAME = 'pitcherPregame',
  PITCHERLIVE = 'pitcherLive',
  PITCHERPOSTGAME = 'pitcherPostgame',
  HITTERLIVE = 'hitterLive'
};

export enum PitchingDecisionTypes {
  W = 'W',
  L = 'L',
  SV = 'SV',
  S = 'S'
};

export enum PlayerMatchupFormats {
  ORIGINAL = 'original',
  VISUAL = 'visual',
  LIST = 'list'
};

export interface PlayerMatchupProps extends HeadshotProps {
  type: PlayerMatchupTypes;
  headshotWidth?: string | number;
  name?: string;
  alignment?: 'left' | 'right';
  linkProps?: LinkProps;
  jerseyNumber?: number;
  pitchHand?: string; // RHP / LHP / Whats the switch type?
  decision?: PitchingDecisionTypes;
  playerStats?: React.ReactNode | string;
  noNameLabel?: string;
  simpleInline?: boolean;
  stacked?: boolean;
  showHeadShot?: boolean;
  playerStatsInline?: boolean;
  format?: PlayerMatchupFormats;
  customPlayerInfo?: string;
  battingOrder?: number;
  useDecisionBox?: boolean;
}
